import defaultValues from '../lib/defaultValues.js'

const state = {
  brokerageName: defaultValues.realtorBrokerageName,
  licenseNumber: defaultValues.realtorLicenseNumber,
  phoneNumber: defaultValues.realtorPhoneNumber,
  profilePicture: defaultValues.realtorProfilePicture,
  realtorCode: defaultValues.realtorCode,
  realtorCognitoId: defaultValues.realtorCognitoId,
  realtorBackgroundColor: defaultValues.realtorBackgroundColor,
  realtorEmail: defaultValues.realtorEmail,
  realtorName: defaultValues.realtorName,
  realtorPaymentHistory: JSON.parse(JSON.stringify(defaultValues.realtorPaymentHistory)),
  realtorTextColor: defaultValues.realtorTextColor,
  subscriptionId: defaultValues.realtorSubscriptionId,
  subscriptionPrice: defaultValues.realtorSubscriptionPrice,
  subscriptionDiscountAmount: defaultValues.realtorSubscriptionDiscountAmount,
  subscriptionDiscountExpirationDate: defaultValues.realtorSubscriptionDiscountExpirationDate,
  subscriptionStartDate: defaultValues.realtorSubscriptionStartDate,
  subscriptionEndDate: defaultValues.realtorSubscriptionEndDate,
  subscriptionNextBillingDate: defaultValues.realtorSubscriptionNextBillingDate,
  subscriptionCreditCardType: defaultValues.realtorSubscriptionCreditCardType,
  subscriptionCreditCardLastFour: defaultValues.realtorSubscriptionCreditCardLastFour,
  subscriptionCustomFlag: defaultValues.realtorSubscriptionCustomFlag,
  subscriptionRenewal: defaultValues.realtorSubscriptionRenewal,
  clientIds: JSON.parse(JSON.stringify(defaultValues.realtorClientIds)),
  braintreeCustomerId: defaultValues.realtorBraintreeCustomerId,
  premium: defaultValues.realtorPremium
}

const getters = {
  getBrokerageName: (state) => {
    return state.brokerageName
  },
  getLicenseNumber: (state) => {
    return state.licenseNumber
  },
  getPhoneNumber: (state) => {
    if (!state.phoneNumber) return state.phoneNumber
    let x = state.phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
  },
  getProfilePicture: (state) => {
    if (state.profilePicture && window.CONFIG && state.realtorCognitoId && state.profilePicture.includes(state.realtorCognitoId)) {
      let baseURL = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/'
      return baseURL + state.profilePicture
    }
    return state.profilePicture
  },
  getRealtorCode: (state) => {
    return state.realtorCode
  },
  getRealtorCognitoId: (state) => {
    return state.realtorCognitoId
  },
  getRealtorBackgroundColor: (state) => {
    return state.realtorBackgroundColor
  },
  getRealtorEmail: (state) => {
    return state.realtorEmail
  },
  getRealtorName: (state) => {
    return state.realtorName
  },
  getRealtorPaymentHistory: (state) => {
    return state.realtorPaymentHistory
  },
  getRealtorTextColor: (state) => {
    return state.realtorTextColor
  },
  getSubscriptionId: (state) => {
    return state.subscriptionId
  },
  getSubscriptionPrice: (state) => {
    return state.subscriptionPrice
  },
  getSubscriptionDiscountAmount: (state) => {
    return state.subscriptionDiscountAmount
  },
  getSubscriptionDiscountExpirationDate: (state) => {
    return state.subscriptionDiscountExpirationDate
  },
  getSubscriptionStartDate: (state) => {
    return state.subscriptionStartDate
  },
  getSubscriptionEndDate: (state) => {
    return state.subscriptionEndDate
  },
  getSubscriptionNextBillingDate: (state) => {
    return state.subscriptionNextBillingDate
  },
  getSubscriptionRenewal: (state) => {
    return state.subscriptionRenewal
  },
  getSubscriptionCreditCardType: (state) => {
    return state.subscriptionCreditCardType
  },
  getSubscriptionCreditCardLastFour: (state) => {
    return state.subscriptionCreditCardLastFour
  },
  getSubscriptionCustomFlag: (state) => {
    return state.subscriptionCustomFlag
  },
  getClientIds: (state) => {
    return state.clientIds
  },
  getBraintreeCustomerId: (state) => {
    return state.braintreeCustomerId
  },
  getPremium: (state) => {
    return state.premium
  }
}

const mutations = {
  updateBrokerageName: (state, brokerageName) => {
    state.brokerageName = brokerageName
  },
  updateLicenseNumber: (state, licenseNumber) => {
    state.licenseNumber = licenseNumber
  },
  updatePhoneNumber: (state, phoneNumber) => {
    if (phoneNumber) phoneNumber = phoneNumber.match(/(\d+)/g).join('')
    state.phoneNumber = phoneNumber
  },
  updateProfilePicture: (state, profilePicture) => {
    state.profilePicture = profilePicture
  },
  updateRealtorCode: (state, realtorCode) => {
    state.realtorCode = realtorCode
  },
  updateRealtorCognitoId: (state, realtorCognitoId) => {
    state.realtorCognitoId = realtorCognitoId
  },
  updateRealtorBackgroundColor: (state, realtorBackgroundColor) => {
    state.realtorBackgroundColor = realtorBackgroundColor
  },
  updateRealtorEmail: (state, realtorEmail) => {
    state.realtorEmail = realtorEmail
  },
  updateRealtorName: (state, realtorName) => {
    state.realtorName = realtorName
  },
  updateRealtorPaymentHistory: (state, realtorPaymentHistory) => {
    state.realtorPaymentHistory = realtorPaymentHistory
  },
  updateRealtorTextColor: (state, realtorTextColor) => {
    state.realtorTextColor = realtorTextColor
  },
  updateSubscriptionId: (state, subscriptionId) => {
    state.subscriptionId = subscriptionId
  },
  updateSubscriptionPrice: (state, subscriptionPrice) => {
    state.subscriptionPrice = subscriptionPrice
  },
  updateSubscriptionDiscountAmount: (state, subscriptionDiscountAmount) => {
    state.subscriptionDiscountAmount = subscriptionDiscountAmount
  },
  updateSubscriptionDiscountExpirationDate: (state, subscriptionDiscountExpirationDate) => {
    state.subscriptionDiscountExpirationDate = subscriptionDiscountExpirationDate
  },
  updateSubscriptionStartDate: (state, subscriptionStartDate) => {
    state.subscriptionStartDate = subscriptionStartDate
  },
  updateSubscriptionEndDate: (state, subscriptionEndDate) => {
    state.subscriptionEndDate = subscriptionEndDate
  },
  updateSubscriptionNextBillingDate: (state, subscriptionNextBillingDate) => {
    state.subscriptionNextBillingDate = subscriptionNextBillingDate
  },
  updateSubscriptionRenewal: (state, subscriptionRenewal) => {
    state.subscriptionRenewal = subscriptionRenewal
  },
  updateSubscriptionCreditCardType: (state, subscriptionCreditCardType) => {
    state.subscriptionCreditCardType = subscriptionCreditCardType
  },
  updateSubscriptionCreditCardLastFour: (state, subscriptionCreditCardLastFour) => {
    state.subscriptionCreditCardLastFour = subscriptionCreditCardLastFour
  },
  updateSubscriptionCustomFlag: (state, subscriptionCustomFlag) => {
    state.subscriptionCustomFlag = subscriptionCustomFlag
  },
  updateClientIds: (state, clientIds) => {
    state.clientIds = clientIds
  },
  updateBraintreeCustomerId: (state, braintreeCustomerId) => {
    state.braintreeCustomerId = braintreeCustomerId
  },
  updatePremium: (state, premium) => {
    state.premium = premium
  }
}

const actions = {
  async getBtToken ({ commit, state, rootGetters }) {
    var client = rootGetters.getRealtorApigClientFactory
    var params = {}
    var pathTemplate = '/realtors/bt-token'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async getPaymentHistory ({ commit, state, rootGetters }) {
    var client = rootGetters.getRealtorApigClientFactory
    var params = {}
    var pathTemplate = '/realtors/paymenthistory'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    try {
      if ('data' in result) commit('updateRealtorPaymentHistory', result.data)
    } catch (error) {
      console.log(error)
    }
  },
  async premiumSignup ({ commit, state, rootGetters }, parameters) {
    var client = rootGetters.getRealtorApigClientFactory
    var params = {}
    var pathTemplate = '/realtorpremium/signup'
    var method = 'POST'
    var additionalParams = {}
    var body = {
      'payment_method_nonce': parameters.payload.nonce,
      'promotion_code': parameters.code
    }
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async switchRenewalStatus ({ commit, state, rootGetters }) {
    var client = rootGetters.getRealtorApigClientFactory
    var params = {}
    var pathTemplate = '/realtorpremium/switch'
    var method = 'PATCH'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async getCurrentRealtorData ({ commit, state, rootGetters }, code) {
    var client = rootGetters.getRealtorApigClientFactory
    var params = {'code': code}
    var pathTemplate = '/realtors/{code}'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    try {
      var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      if ('brokerage_name' in result.data) commit('updateBrokerageName', result.data.brokerage_name)
      if ('license_number' in result.data) commit('updateLicenseNumber', result.data.license_number)
      if ('realtor_phone_number' in result.data) commit('updatePhoneNumber', result.data.realtor_phone_number)
      if ('realtor_picture' in result.data) commit('updateProfilePicture', result.data.realtor_picture)
      if ('code' in result.data) commit('updateRealtorCode', result.data.code)
      if ('realtor_cognito_id' in result.data) commit('updateRealtorCognitoId', result.data.realtor_cognito_id)
      if ('background_color' in result.data) commit('updateRealtorBackgroundColor', result.data.background_color)
      if ('text_color' in result.data) commit('updateRealtorTextColor', result.data.text_color)
      if ('realtor_email' in result.data) commit('updateRealtorEmail', result.data.realtor_email)
      if ('realtor_name' in result.data) commit('updateRealtorName', result.data.realtor_name)
      if ('subscription' in result.data) {
        commit('updateSubscriptionId', result.data.subscription.subscription_id)
        commit('updateSubscriptionPrice', result.data.subscription.price)
        commit('updateSubscriptionStartDate', result.data.subscription.billing_period_start_date)
        commit('updateSubscriptionEndDate', result.data.subscription.billing_period_end_date)
        commit('updateSubscriptionCreditCardType', result.data.subscription.credit_card_type)
        commit('updateSubscriptionCreditCardLastFour', result.data.subscription.credit_card_last_four)
        if (result.data.subscription.custom) commit('updateSubscriptionCustomFlag', result.data.subscription.custom)
        if (result.data.subscription.discount_amount) {
          commit('updateSubscriptionDiscountAmount', result.data.subscription.discount_amount)
          commit('updateSubscriptionDiscountExpirationDate', result.data.subscription.discount_expiration_date)
        }
        if (result.data.subscription.next_billing_date) {
          commit('updateSubscriptionNextBillingDate', result.data.subscription.next_billing_date)
          commit('updateSubscriptionRenewal', true)
        } else {
          commit('updateSubscriptionNextBillingDate', defaultValues.realtorSubscriptionNextBillingDate)
          commit('updateSubscriptionRenewal', defaultValues.realtorSubscriptionRenewal)
        }
      }
      if ('client_ids' in result.data) commit('updateClientIds', result.data.client_ids)
      if ('braintree_customer_id' in result.data) commit('updateBraintreeCustomerId', result.data.braintree_customer_id)
      if ('premium' in result.data) commit('updatePremium', result.data.premium)
    } catch (error) {
      console.log(error)
    }
  },
  async putRealtorData ({ commit, state, rootGetters }, { code, method = 'PUT' }) {
    var client = rootGetters.getRealtorApigClientFactory
    var params = {'code': code}
    var pathTemplate = '/realtors/{code}'
    var additionalParams = {}
    var body = {
      'realtor_cognito_id': state.realtorCognitoId,
      'license_number': state.licenseNumber,
      'brokerage_name': state.brokerageName,
      'background_color': state.realtorBackgroundColor,
      'text_color': state.realtorTextColor,
      'realtor_name': state.realtorName,
      'realtor_picture': state.profilePicture,
      'realtor_phone_number': state.phoneNumber,
      'realtor_email': state.realtorEmail
    }
    return client.invokeApi(params, pathTemplate, method, additionalParams, body)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/realtor.js